import fetcher from '../fetcher';
import { PagedResponse } from './admin';

// Types
export interface IndustrySector {
	id: number;
	portofolioGuideline: string;
	ecosystem: string;
	industryClass: string;
	sectorLevel1: string;
	sectorLevel2: string;
	sectorLevel3: string;
	sectorLevel4: string;
	sectorLevel5: string;
	code: string;
}

export interface IndustrySectorListRequest {
	pagination: {
		pageNumber: number;
		pageSize: number;
	};
	search?: {
		by: 'name' | 'code';
		value: string;
	};
}

export interface IndustrySectorListResponse
	extends PagedResponse<IndustrySector> {
	// PagedResponse already contains items, currentPage, pageSize, totalPages, items (which maps to items in contract if we adjust PagedResponse or override here)
	// The contract says: items, currentPage, pageSize, totalPages, totalCount
	// fleet-api/services/admin.ts PagedResponse has: totalCount, pageSize, currentPage, totalPages, items
	// So it matches perfect.
}

export interface CreateIndustrySectorRequest {
	portofolioGuideline: string;
	ecosystem: string;
	industryClass: string;
	sectorLevel1: string;
	sectorLevel2: string;
	sectorLevel3: string;
	sectorLevel4: string;
	sectorLevel5: string;
	code?: string;
}

export interface UpdateIndustrySectorRequest {
	id: number;
	portofolioGuideline?: string;
	ecosystem?: string;
	industryClass?: string;
	sectorLevel1?: string;
	sectorLevel2?: string;
	sectorLevel3?: string;
	sectorLevel4?: string;
	sectorLevel5?: string;
	code?: string;
}

// Services
export const getIndustrySectorList = (payload: IndustrySectorListRequest) => {
	return fetcher<IndustrySectorListResponse>({
		api: '/admin/industry-sector/list',
		method: 'POST',
		body: payload as unknown as Record<string, unknown>,
	});
};

export const createIndustrySector = (payload: CreateIndustrySectorRequest) => {
	return fetcher<{ message: string }>({
		api: '/admin/industry-sector/add',
		method: 'POST',
		body: payload as unknown as Record<string, unknown>,
	});
};

export const updateIndustrySector = (payload: UpdateIndustrySectorRequest) => {
	return fetcher<{ message: string }>({
		api: '/admin/industry-sector/update',
		method: 'POST',
		body: payload as unknown as Record<string, unknown>,
	});
};

export const deleteIndustrySector = (id: number) => {
	return fetcher<{ message: string }>({
		api: `/admin/industry-sector/delete/${id}`,
		method: 'POST',
	});
};

// React Query Keys
export const industrySectorKeys = {
	all: ['industry-sectors'] as const,
	lists: () => [...industrySectorKeys.all, 'list'] as const,
	list: (filter: IndustrySectorListRequest) =>
		[...industrySectorKeys.lists(), filter] as const,
};
